import { render, staticRenderFns } from "./uploadStudent.vue?vue&type=template&id=757de99f&scoped=true"
import script from "./uploadStudent.vue?vue&type=script&lang=js"
export * from "./uploadStudent.vue?vue&type=script&lang=js"
import style0 from "./uploadStudent.vue?vue&type=style&index=0&id=757de99f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757de99f",
  null
  
)

export default component.exports